import { TagChip } from "./TagChip";
import { FilteredValueGroupData } from "helpers/hooks/useFilteredValueGroups";
import { STARRED_TAG, UNTAGGED } from "components/tags/constants";
import { Star } from "@mui/icons-material";
import { cn } from "components/lib/utils";
import { TagColorKind } from "generated/graphql";
import { useContext } from "react";
import { FormFieldContext } from "contexts/FormFieldContext";

type TagFilterProps = Pick<FilteredValueGroupData, "availableTags" | "tagFilters" | "setTagFilters" | "tagCounts">;

const sharedClasses = "cursor-pointer select-none";

export function TagFilters({ availableTags, tagFilters, setTagFilters, tagCounts }: TagFilterProps) {
  const ffContext = useContext(FormFieldContext);
  const toggleTag = (tag: string) => () => {
    setTagFilters((old: Set<string>) => {
      if (old.has(tag)) return new Set(Array.from(old).filter((t) => t !== tag));
      return new Set([...old, tag]);
    });
  };
  return (
    <>
      <TagChip
        onClick={toggleTag(STARRED_TAG)}
        className={sharedClasses}
        readOnly={!tagCounts[STARRED_TAG]}
        key="starred"
        active={tagFilters.has(STARRED_TAG)}
        tag={{
          systemName: STARRED_TAG,
          displayName: STARRED_TAG,
          count: tagCounts[STARRED_TAG] ?? 0,
          color: TagColorKind.Gray,
        }}
        startAdornment={
          <Star className={cn("h-4 w-4 mr-1", tagFilters.has(STARRED_TAG) ? "text-gold" : "text-gray-300")} />
        }
      />
      {availableTags
        // if there's nothing tagged, don't show the filtered unless it's filtered by default
        .filter((t) => (tagCounts[t.systemName] ?? 0) > 0 || t.filteredByDefaultFields.includes(ffContext.formField.id))
        .map((t, i) => (
          <TagChip
            className={sharedClasses}
            onClick={toggleTag(t.systemName)}
            key={i}
            active={tagFilters.has(t.systemName)}
            tag={t}
          />
        ))}
      {availableTags.length > 0 && (
        <TagChip
          onClick={toggleTag(UNTAGGED)}
          className={sharedClasses}
          key="untagged"
          active={tagFilters.has(UNTAGGED)}
          tag={{ systemName: UNTAGGED, displayName: UNTAGGED, count: tagCounts[UNTAGGED], color: TagColorKind.Gray }}
        />
      )}
    </>
  );
}
